import api from './api';
import { repackOrganizationId } from '../config';
import { bessActions } from '../redux/actions';
import { setSystemsLoading } from '../redux/actions/bessActions';

export const getAllSystems = (organizationId) => {
  return (dispatch, getState) => {
    dispatch(setSystemsLoading());
    api
      .get(`/api/v1/battery-energy-storage-systems/`)
      .then((systems) => {
        const userSystems =
          organizationId === repackOrganizationId
            ? systems
            : systems.filter(
                (system) => system.organizationId === organizationId
              );

        return dispatch(bessActions.setSystems(userSystems.reverse()));
      })
      .then(() => {
        getState().bessReducer.overview.systems.forEach((system) => {
          dispatch(getSystemDetails(system.id));
        });
      });
  };
};

export const getSystemDetails = (systemId) => {
  return (dispatch) => {
    api
      .get(`/api/v1/battery-energy-storage-systems/${systemId}`)
      .then((systemDetails) => {
        const numberOfCabinets = systemDetails.cabinets.length;
        let numberOfModules = 0;
        let numberOfCells = 0;
        systemDetails.cabinets.forEach((cabinet) => {
          numberOfModules += cabinet.modules.length;
          cabinet.modules.forEach((module) => {
            numberOfCells += module.cells.length;
          });
        });

        dispatch(
          bessActions.setSystemDetails(
            {
              ...systemDetails,
              numberOfCabinets,
              numberOfModules,
              numberOfCells
            },
            systemId
          )
        );
      });
  };
};
